import React, { useState, useEffect } from "react";
import i18n from "../i18n";
import sanityClient from "../sanityClient";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../styles/projects.css";

function ProjectGallery() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProjects = async (language) => {
    try {
      setLoading(true);

      const query = `*[_type == "project" && language == $language]{
        _id,
        title,
        description,
        "images": images[].asset->url
      }`;

      const data = await sanityClient.fetch(query, { language });
      setProjects(data);
    } catch (err) {
      console.error("Error fetching projects:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects(i18n.language);

    const handleLanguageChange = (lng) => {
      fetchProjects(lng);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  if (loading) return <p>Loading projects...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <section id="projects" className="projects-gallery">
      <h3>{i18n.t("projectGallery.title")}</h3>
      <div className="projects-container">
        {projects.map((project) => (
          <div key={project._id} className="project-card">
            <h4>{project.title}</h4>
            <p>{project.description}</p>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={10}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              className="project-swiper"
            >
              {project.images.map((image, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={image}
                    alt={`${project.title} Image ${index + 1}`}
                    className="project-image"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProjectGallery;
